import { render } from "./menu.vue?vue&type=template&id=6c317be4&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=6c317be4&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c317be4"],['__file',"src/vab/components/VabMyMenu/menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c317be4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c317be4', __exports__)) {
    console.log('reload')
    api.reload('6c317be4', __exports__)
  }
  
  module.hot.accept("./menu.vue?vue&type=template&id=6c317be4&scoped=true", () => {
    console.log('re-render')
    api.rerender('6c317be4', render)
  })

}


export default __exports__